import Component from './ResetPassword.vue';

export default Component;
